import React from "react";

interface ButtonProps {
  text?: string; // The caption for the button
  type: "primary" | "secondary"; // Button type (primary or secondary)
  onClick?: () => void; // Optional click event handler
  children?: React.ReactNode;
  disabled?: boolean;
}

export const Button: React.FC<ButtonProps> = ({
  text,
  children,
  type,
  onClick,
  disabled = false,
}) => {
  const baseStyles = `px-4 py-2 text-white font-semibold rounded-md transition-all duration-300`;
  const primaryStyles = `bg-perle-red hover:bg-perle-dark-red`; // Primary button styles
  const secondaryStyles = `bg-dark-gray-1 text-[#000]`; // Secondary button styles

  const buttonStyles =
    type === "primary"
      ? `${baseStyles} ${primaryStyles}`
      : `${baseStyles} ${secondaryStyles}`;

  return (
    <button className={buttonStyles} onClick={onClick} disabled={disabled}>
      {children || text}
    </button>
  );
};
